export default __webpack_public_path__ + "static/media/classic.5110193c.jpg";